export enum COMMON_STATUS {
	ACTIVE = "active",
	INACTIVE = "inactive",
}
